export default __webpack_public_path__ + "static/media/logo-dark.faf1b642.svg";